
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Asignar from "./pages/Asignar";
import FormularioViatico from "./pages/FormularioViatico";
import Historial from "./pages/Historial";
import PanelConductor from "./pages/PanelConductor";
import SolicitudViatico from "./pages/SolicitudViatico";
import SolicitudesAdmin from "./pages/SolicitudesAdmin";
import MisSolicitudes from "./pages/MisSolicitudes";
import LiquidacionesAdmin from "./pages/LiquidacionesAdmin";
import GestionConductores from "./pages/GestionConductores";
import GestionCamiones from "./pages/GestionCamiones";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Inicio de sesión */}
        <Route path="/" element={<Login />} />

        {/* Panel principal */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Gestión de viáticos */}
        <Route path="/asignar" element={<Asignar />} />
        <Route
          path="/formulario-viatico/:id_conductor"
          element={<FormularioViatico />}
        />
        <Route path="/historial" element={<Historial />} />
        

        {/* Funciones del conductor */}
        <Route
          path="/panel-conductor"
          element={<PanelConductor />}
        />
        <Route
          path="/solicitar-viatico"
          element={<SolicitudViatico />}
        />
        <Route
          path="/mis-solicitudes"
          element={<MisSolicitudes />}
        />

        {/* Funciones del administrador */}
        <Route
          path="/solicitudes-admin"
          element={<SolicitudesAdmin />}
        />
        <Route
          path="/liquidaciones-admin"
          element={<LiquidacionesAdmin />}
        />

        {/* Nueva gestión de conductores */}
        <Route
          path="/gestion-conductores"
          element={<GestionConductores />}
        />
        <Route
          path="/gestion-camiones"
          element={<GestionCamiones />}
        />
      </Routes>
    </Router>
  );
}
